/**
 * Pure coordinate conversion functions for crop modal
 */

/**
 * Converts original image coordinates to display coordinates
 */
export const toDisplayCoords = (
  originalOffset: number,
  naturalDimension: number,
  clientDimension: number,
): number => {
  return naturalDimension === 0 ? 0 : originalOffset * (clientDimension / naturalDimension);
};

/**
 * Converts display coordinates to original image coordinates
 */
export const toOriginalCoords = (
  displayOffset: number,
  naturalDimension: number,
  clientDimension: number,
): number => {
  return clientDimension === 0
    ? 0
    : Math.round(displayOffset * (naturalDimension / clientDimension));
};
